import { LogoLangCode } from '@standardsdigital/ui-components/Logo';

const getLogoLangCode = (language: string | undefined): LogoLangCode | undefined => {
  if (language === 'nb') {
    return LogoLangCode.NO;
  }

  if (Object.values(LogoLangCode).includes(language as LogoLangCode)) {
    return language as LogoLangCode;
  }

  return undefined;
};

export default getLogoLangCode;
